import React from 'react'
import styled from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'

const SECTION_HEADER_FONT_SIZE = 15

const Container = styled.div<{ size?: number }>`
    font-size: ${props => (props.size ? `${props.size}px` : `${SECTION_HEADER_FONT_SIZE}px`)};
    font-weight: 600;
    -webkit-font-smoothing: antialiased;
    color: ${giphyWhite};
    padding: 0 1px;
    display: flex;
    & span {
        margin-right: -1px;
    }
`

type Props = {
    size?: number
}

export const TrendingHeader = ({ size }: Props) => {
    return (
        <Container size={size}>
            <h2>
                <span>T</span>rending
            </h2>
        </Container>
    )
}
